/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkflowTransitionResponse
 */
export interface WorkflowTransitionResponse {
    /**
     * 
     * @type {Array<TaskInfo>}
     * @memberof WorkflowTransitionResponse
     */
    tasks: Array<TaskInfo>;
}

export function WorkflowTransitionResponseFromJSON(json: any): WorkflowTransitionResponse {
    return WorkflowTransitionResponseFromJSONTyped(json, false);
}

export function WorkflowTransitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowTransitionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tasks': ((json['tasks'] as Array<any>).map(TaskInfoFromJSON)),
    };
}

export function WorkflowTransitionResponseToJSON(value?: WorkflowTransitionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tasks': ((value.tasks as Array<any>).map(TaskInfoToJSON)),
    };
}


